// import React, {useEffect, useState, useRef} from 'react'

// const useRecording = (options) => {
//     const [isListening, setIsListening] = useState(false);
//     const [transcript, setTranscript] = useState("");
//     const recognitationRef = useRef(null);

// useEffect(()=>{
//     if(!('webkitSpeechRecognition' in window)){
//         console.error('Web speech API is not supported')
//         return;
//     }

//     recognitationRef.current = new window.webkitSpeechRecognition()
//     const recognition = recognitationRef.current;
//     recognition.interimResults = options.interimResults || true;
//     recognition.lang = options.lang || "en-US";
//     recognition.continuous = options.continuous || false;

//     if("webkitSpeechGrammarList" in window){
//         const grammar = "#JSGF V1.0; grammar punctuation; public <punc> = . | , | ? | ! | ; | : ;";
//         const speechRecognitionList = new window.webkitSpeechGrammarList();
//         speechRecognitionList.addFromString(grammar, 1);
//         recognition.grammars = speechRecognitionList;
//     }

//     recognition.onresult = (event) => {
//         let text = ""
//         for(let i=0; i<event.results.length; i++){
//             text += event.results[i][0].transcript
//         }
//         setTranscript(text)
//     }

//     recognition.onerror = (event) => {
//         console.error("Speech recognition error:", event.error)
//     }

//     recognition.onend = () => {
//         setIsListening(false)
//         setTranscript("")
//     }

//     return()=>{
//         recognition.stop();
//     }
// },[])


//     const startListening = () => {
//         if(recognitationRef.current && !isListening){
//             recognitationRef.current.start();
//             setIsListening(true);
//         }
//     }

//     const stopListening = () => {
//         if(recognitationRef.current && isListening){
//             recognitationRef.current.stop();
//             setIsListening(false);
//         }
//     }
    
    
//     return{
//         isListening,
//         transcript,
//         startListening,
//         stopListening
//     }
// }

// export default useRecording;


import React, { useEffect, useState, useRef } from 'react';

const useRecording = (options) => {
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const recognitationRef = useRef(null);
  const lastTranscriptRef = useRef(""); // To store the last processed transcript

  useEffect(() => {
    if (!('webkitSpeechRecognition' in window)) {
      console.error('Web speech API is not supported');
      return;
    }

    recognitationRef.current = new window.webkitSpeechRecognition();
    const recognition = recognitationRef.current;
    
    // Adjust settings based on options and platform
    recognition.interimResults = options.interimResults || true;
    recognition.lang = options.lang || "en-US";
    recognition.continuous = /Android/i.test(navigator.userAgent) ? false : options.continuous || true;

    // Add grammar if supported
    if ("webkitSpeechGrammarList" in window) {
      const grammar = "#JSGF V1.0; grammar punctuation; public <punc> = . | , | ? | ! | ; | : ;";
      const speechRecognitionList = new window.webkitSpeechGrammarList();
      speechRecognitionList.addFromString(grammar, 1);
      recognition.grammars = speechRecognitionList;
    }

    recognition.onresult = (event) => {
      let text = "";
      for (let i = 0; i < event.results.length; i++) {
        text += event.results[i][0].transcript;
      }

      // Check for duplicate text
      if (text !== lastTranscriptRef.current) {
        setTranscript(text);
        lastTranscriptRef.current = text;
      }
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
    };

    recognition.onend = () => {
      setIsListening(false);

      if (isListening) {
        // Automatically restart if it's supposed to be continuous
        recognition.start();
    }
    };

    return () => {
      recognition.stop();
    };
  }, []);

  const startListening = () => {
    if (recognitationRef.current && !isListening) {
      recognitationRef.current.start();
      setIsListening(true);
    }
  };

  const stopListening = () => {
    if (recognitationRef.current && isListening) {
      recognitationRef.current.stop();
      setIsListening(false);
    }
  };

  return {
    isListening,
    transcript,
    startListening,
    stopListening,
    setIsListening,
    setTranscript
  };
};

export default useRecording;
